import { createTypes } from 'redux-compose-reducer';
import { getSU, putSU, postSU, getSUME } from 'utils/apiRequester';
import { authError } from './auth';
import config from 'config';
import { chartPageType } from '../pages/stats_acc/StatsAcc';
import moment from 'moment';
import { envChartPageType } from '../pages/stats_acc_per_env/StatsAccPerEnv';
import { dailyStatsChartPageType } from '../pages/daily_stats/DailyStats';

const { envsArray } = config;

export const TYPES = createTypes('superuser', [
  'getAllPsychicsInfoAndStatitstic',
  'getUserByEmail',
  'updateUser',
  'getUserReportsByEmail',
  'getCohortSearch',
  'getManagers',
  'setSingleManagerStats',
  'setManagersStats',
  'setEnvStats',
  'setDailyStats'
]);

export function getAllPsychicsInfoAndStatitstic(dispatch) {
  return getSU('/admin/aio')
    .then(({ data }) => {
      return dispatch({
        type: TYPES.getAllPsychicsInfoAndStatitstic,
        data: data
      });
    })
    .catch(err => authError(dispatch, err, history));
}


export function getUserByEmail(dispatch, email) {
  return getSU(`/admin/user?email=${ email }`)
    .then(({ data }) => {
      return dispatch({
        type: TYPES.getUserByEmail,
        data: data
      });
    })
    .catch(err => {
      try {
        if (err.response.status === 400) {
          return dispatch({
            type: TYPES.getUserByEmail,
            data: null
          });
        }
      } catch (e) {
        authError(dispatch, err, history);
      }
    });
}

export function getUserReportsByEmail(dispatch, email) {
  return getSU(`/admin/get-user-reports?email=${ email }`)
    .then(({ data }) => {
      return dispatch({
        type: TYPES.getUserReportsByEmail,
        data: data
      });
    })
    .catch(err => {
      try {
        if (err.response.status === 400) {
          return dispatch({
            type: TYPES.getUserReportsByEmail,
            data: null
          });
        }
      } catch (e) {
        authError(dispatch, err, history);
      }
    });
}

export function updateUser(dispatch, data) {
  return putSU('/admin/user', data)
    .then(({ data }) => {
      return dispatch({
        type: TYPES.updateUser,
        data: data
      });
    })
    .catch(err => authError(dispatch, err, history));
}

export function giveFreeQuestion(dispatch, data) {
  return postSU('/admin/free-q', data)
    .then(() => {
    })
    .catch(err => authError(dispatch, err, history));
}

export function getCohortSearch(dispatch, data) {
  return getSU('/admin/sort-by-report', data)
    .then(res => {
      return dispatch({
        type: TYPES.getCohortSearch,
        data: res.data
      });
    })
    .catch(err => authError(dispatch, err, history));
}

export function getManagers(dispatch, data) {
  return getSU('/admin/managers', data)
    .then(res => {
      return dispatch({
        type: TYPES.getManagers,
        data: res.data
      });
    })
    .catch(err => authError(dispatch, err, history));
}

export async function getManagerStats(dispatch, data) {
  const respData = {};
  const total = { messageStats: [], adminTimeStats: [], lastMessages: [] };

  const promises = [];
  for (const env of envsArray) {
    promises.push(getSUME(`${ env.url }/admin/manager-stats`, data)
      .then(response => {
        respData[env.name] = response.data;
      })
      .catch(err => authError(dispatch, err, history, false)));
  }

  await Promise.all(promises);

  Object.keys(respData).map(k => {
    const envStats = respData[k];
    total.messageStats = total.messageStats.concat(envStats.messageStats);
    total.adminTimeStats = total.adminTimeStats.concat(envStats.adminTimeStats);
    total.lastMessages = total.lastMessages.concat(envStats.lastMessages);
  });

  const sortedMessages = total.lastMessages.sort((a, b) => moment(b.createdAt) - moment(a.createdAt));
  total.sortedMessages = sortedMessages.slice(0, 20);

  console.log(sortedMessages);
  respData['Total'] = total;


  return dispatch({
    type: TYPES.setSingleManagerStats,
    data: respData
  });

}

export async function getManagersStats(dispatch, data, type) {
  const respData = {};

  const promises = [];

  let relPath;
  switch (type) {
    case chartPageType.conversions:
      relPath = '/admin/manager-conversation-stats-all';
      break;
    case chartPageType.messagesTime:
    default:
      relPath = '/admin/manager-stats-all';
      break;
  }

  for (const env of envsArray) {
    promises.push(getSUME(`${ env.url }${ relPath }`, data)
      .then(response => {
        respData[env.name] = response.data;
      })
      .catch(err => authError(dispatch, err, history, false)));
  }

  await Promise.all(promises);

  return dispatch({
    type: TYPES.setManagersStats,
    data: respData
  });
}


export async function getEnvMessagesStats(dispatch, data, type) {
  const respData = {};

  const promises = [];

  let relPath;
  switch (type) {
    case envChartPageType.messagesRevenue:
    default:
      relPath = '/admin/message-stats-all';
      break;
  }

  for (const env of envsArray) {
    promises.push(getSUME(`${ env.url }${ relPath }`, data)
      .then(response => {
        respData[env.name] = response.data;
      })
      .catch(err => authError(dispatch, err, history, false)));
  }

  await Promise.all(promises);

  return dispatch({
    type: TYPES.setEnvStats,
    data: respData
  });
}

export async function getDailyStats(dispatch, data, type) {
  const respData = {};

  const promises = [];

  let relPath;
  switch (type) {
    case dailyStatsChartPageType.sales:
    default:
      relPath = '/admin/daily-stats';
      break;
  }

  for (const env of envsArray) {
    promises.push(getSUME(`${ env.url }${ relPath }`, data)
      .then(response => {
        respData[env.name] = response.data;
      })
      .catch(err => authError(dispatch, err, history, false)));
  }

  await Promise.all(promises);

  return dispatch({
    type: TYPES.setDailyStats,
    data: respData
  });
}

export function clearManagerStats(dispatch) {
  return dispatch({ type: TYPES.setSingleManagerStats, data: {} });
}

export function clearManagersStats(dispatch) {
  return dispatch({ type: TYPES.setManagersStats, data: {} });
}

export function clearEnvStats(dispatch) {
  return dispatch({ type: TYPES.setEnvStats, data: {} });
}

export function clearDailyStats(dispatch) {
  return dispatch({ type: TYPES.setDailyStats, data: {} });
}



// WEBPACK FOOTER //
// ./src/actions/superuser.js